import _ from 'lodash';
import { PageParamsFactory } from 'pages/document/DocumentComponent/helpers';

export function createPageParams(rotationState: Record<number, number> | null | undefined) {
  return (idx: number) => {
    const lsRotate = _.get(rotationState, idx);
    const rotate = _.isNumber(lsRotate) ? lsRotate : 0;
    return PageParamsFactory({ idx, rotate });
  };
}
